import React, { useMemo } from 'react'
import type { MenuItem } from '../../../models/types'
import DashboardItem from './DashboardItem'

interface DashboardLineProps {
  title?: string
  tiles: Array<MenuItem>
  onClick: () => void
}

const DashboardLine = ({ title, tiles, onClick }: DashboardLineProps): JSX.Element => {
  const processedItems = useMemo<Array<MenuItem>>(() => {
    return tiles.slice().sort((item1, item2) => item1.index - item2.index)
  }, [tiles])

  return (
    <div className='rf-w-full rf-flex rf-flex-col rf-justify-start rf-gap-4'>
      {/* Title */}
      {title && <div className='rf-title-bold-size-auto'>{title}</div>}

      {/* Items */}
      <div className='rf-flex rf-flex-row rf-gap-6 rf-flex-wrap'>
        {processedItems.map((item, key) => {
          return <DashboardItem key={key} {...item} onClick={onClick} />
        })}
      </div>
    </div>
  )
}

export default DashboardLine
